module.exports = __webpack_public_path__ + "static/media/competitive.82c20cb4.svg";